module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gm-6e4caca46e637e40175f81818f07cd88.svg";